import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {CommonService} from './common.service';
import {ToastMessagesService} from './toast-messages.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public notifications: any[];
  public notificationSubject = new BehaviorSubject<any>([]);
  displayNotifications = this.notificationSubject.asObservable();

  constructor(public toastMessagesService: ToastMessagesService, private commonService: CommonService) {
  }

  getInCompleteNotifications() {
    if (!this.notifications) return [];
    return this.notifications.filter(notification => notification.is_completed === 0 && notification.mode !== 'display');
  }

  getCompletedNotifications() {
    if (!this.notifications) return [];
    return this.notifications.filter(notification => notification.is_completed === 1 && notification.mode !== 'display');
  }

  /**
   * Get notifications for the current user (Single User Model - no children)
   */
  async getUserNotifications(force: boolean) {
    try {
      if (force || !this.notifications) {
        const notificationRequest = await this.commonService.getList(`people/user/notifications`);
        this.notifications = notificationRequest.object;
        this.notificationSubject.next(this.notifications);
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  /**
   * @deprecated Use getUserNotifications instead for Single User Model
   */
  async getAllNotifications(userId: number, force: boolean) {
    // Redirect to new Single User Model endpoint
    await this.getUserNotifications(force);
  }
}
